import LoadingButton from "@mui/lab/LoadingButton";
import { SxProps } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import React from "react";

export interface IAppButtonProps extends ButtonProps {
  label: string;
  isShow?: boolean;
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit";
  href?: string;
  variant?: "contained" | "outlined" | "text" | "soft";
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning" | "inherit";
  sx?: SxProps;
  fullWidth?: boolean;

  target?: "_blank" | "_self" | "_parent" | "_top";
}

export const AppButton: React.FC<IAppButtonProps> = (props) => {
  const {
    label,
    isLoading = false,
    onClick,
    href,
    type = "button",
    variant = "contained",
    color = "primary",
    fullWidth = true,
    sx,
    target,
    ...other
  } = props;

  return (
    <LoadingButton
      loading={isLoading}
      onClick={onClick}
      type={type}
      color={color}
      variant={variant}
      fullWidth={fullWidth}
      href={href}
      sx={{
        borderRadius: 7.5,
        textTransform: "capitalize",
        ...sx,
      }}
      {...other}
    >
      {label}
    </LoadingButton>
  );
};

export default AppButton;
